const products = [
  {name:'Marshline Classic Tee', price:34, type:'tees', color:'cream', art:'marsh', badge:'BEST SELLER'},
  {name:'Carolina Pines Tee', price:34, type:'tees', color:'pine', art:'pine', badge:'NEW'},
  {name:'Tide & Pine Logo Tee', price:34, type:'tees', color:'cream', art:'logo', badge:'NEW'},
  {name:'Tide & Pine Rope Hat', price:32, type:'hats', color:'blue', art:'mark', badge:'BEST SELLER'},
  {name:'Low Country Lab Tee', price:36, type:'tees', color:'sand', art:'lab'},
  {name:'Marsh Duck Patch Hat', price:32, type:'hats', color:'khaki', art:'duck'},
  {name:'Boat Ramp Social Club Tee', price:34, type:'tees', color:'blue', art:'boat'},
  {name:'Heron Rope Hat', price:32, type:'hats', color:'cream', art:'heron'},
  {name:'Southern By Nature Tee', price:34, type:'tees', color:'pine', art:'nature'}
];

const art = {
  marsh:'<span>THE<br><b>MARSHLINE</b><small>CAROLINA COAST</small></span>',
  pine:'<span class="tree">A</span><b>CAROLINA<br>PINES</b><small>COAST / WOODS / HOME</small>',
  logo:'<b>TIDE &<br>PINE</b><small>OFFICIAL LOGO TEE</small>',
  mark:'<b class="tp">T&P</b><small>CAROLINAS</small>',
  lab:'<span class="dog">D</span><b>LOW COUNTRY<br>LAB</b><small>GOOD DOGS / HIGH TIDES</small>',
  duck:'<span class="patch">MARSH<br>DUCK</span>',
  boat:'<span class="boat">~</span><b>BOAT RAMP<br>SOCIAL CLUB</b>',
  heron:'<span class="heron">T</span><b>TIDE & PINE</b>',
  nature:'<span class="tree">A</span><b>SOUTHERN<br>BY NATURE</b>'
};

const grid = document.querySelector('#product-grid');
let currentFilter = 'all';
let expanded = false;

function renderProducts(){
  if(!grid) return;
  if(grid.dataset.staticProducts === 'true') return;
  const matches = products.filter(product => currentFilter === 'all' || product.type === currentFilter);
  const visible = matches.slice(0, expanded ? 8 : 4);
  grid.innerHTML = visible.map((product, index) => `
    <article class="product-card reveal visible" style="--delay:${index * 60}ms">
      <div class="product-image ${product.color}">
        ${product.badge ? `<span class="product-badge">${product.badge}</span>` : ''}
        <div class="${product.type === 'hats' ? 'hat-shape' : 'tee-shape'}"><div class="product-art ${product.art}">${art[product.art]}</div></div>
        <a class="quick-add" href="/collections/${product.type}" aria-label="Shop ${product.name}">SHOP NOW <span>+</span></a>
      </div>
      <div class="product-meta"><div><h3>${product.name}</h3><p>${product.type === 'hats' ? 'Classic Rope Hat' : 'Comfort Colors Tee'}</p></div><strong>$${product.price}.00</strong></div>
    </article>`).join('');
  const viewAll = document.querySelector('#view-all');
  if(viewAll) viewAll.style.display = visible.length < matches.length ? 'inline-flex' : 'none';
}

function setFilter(filter){
  currentFilter = filter;
  expanded = false;
  document.querySelectorAll('.filters button').forEach(button => button.classList.toggle('active', button.dataset.filter === filter));
  if(grid && grid.dataset.staticProducts === 'true'){
    grid.querySelectorAll('[data-product-type]').forEach(card => {
      card.style.display = filter === 'all' || card.dataset.productType === filter ? '' : 'none';
    });
    return;
  }
  renderProducts();
}

document.querySelectorAll('[data-filter]').forEach(element => {
  element.addEventListener('click', () => setFilter(element.dataset.filter));
});

const viewAll = document.querySelector('#view-all');
if(viewAll) viewAll.addEventListener('click', () => {
  expanded = true;
  renderProducts();
});

const mobile = document.querySelector('.mobile-menu');
function toggleMenu(open){
  if(!mobile) return;
  mobile.classList.toggle('open', open);
  mobile.setAttribute('aria-hidden', !open);
  const trigger = document.querySelector('.menu-toggle');
  if(trigger) trigger.setAttribute('aria-expanded', open);
}

const menuToggle = document.querySelector('.menu-toggle');
const menuClose = document.querySelector('.menu-close');
if(menuToggle) menuToggle.addEventListener('click', () => toggleMenu(true));
if(menuClose) menuClose.addEventListener('click', () => toggleMenu(false));
if(mobile) mobile.querySelectorAll('a').forEach(link => link.addEventListener('click', () => toggleMenu(false)));

function closeMediaLightbox(){
  const lightbox = document.querySelector('.media-lightbox');
  if(lightbox) lightbox.classList.remove('open');
}

function openMediaLightbox(src, alt){
  let lightbox = document.querySelector('.media-lightbox');
  if(!lightbox){
    lightbox = document.createElement('div');
    lightbox.className = 'media-lightbox';
    lightbox.innerHTML = '<button type="button" aria-label="Close image">&times;</button><img alt="">';
    document.body.appendChild(lightbox);
    lightbox.addEventListener('click', event => {
      if(event.target === lightbox || event.target.tagName === 'BUTTON') closeMediaLightbox();
    });
    document.addEventListener('keydown', event => {
      if(event.key === 'Escape') closeMediaLightbox();
    });
  }
  const image = lightbox.querySelector('img');
  image.src = src;
  image.alt = alt || '';
  lightbox.classList.add('open');
}

function bindMediaZoom(){
  document.querySelectorAll('[data-media-zoom]').forEach(button => {
    if(button.dataset.mediaZoomBound === 'true') return;
    button.dataset.mediaZoomBound = 'true';
    button.addEventListener('click', () => {
      const image = button.querySelector('img');
      openMediaLightbox(button.dataset.mediaZoom, image ? image.alt : '');
    });
  });
}

bindMediaZoom();

const observer = new IntersectionObserver(entries => entries.forEach(entry => {
  if(entry.isIntersecting) entry.target.classList.add('visible');
}), {threshold:.12});
document.querySelectorAll('.reveal').forEach(element => observer.observe(element));

window.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');
  if(header) header.classList.toggle('scrolled', scrollY > 40);
});

document.addEventListener('shopify:section:load', () => {
  renderProducts();
  bindMediaZoom();
});

renderProducts();
